import React from 'react';
import { motion } from 'framer-motion';
import brandLogo from '../assets/Brand.jpeg';

const Loader = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#061225]" style={{ fontFamily: 'emoji' }}>
      {/* Outer spinning dashed ring for modern look */}
      <motion.div
        className="absolute w-48 h-48 rounded-full border-t-2 border-b-2 border-blue-500 opacity-60"
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1.5, ease: "linear" }}
      />
      
      {/* Inner spinning dotted ring */}
      <motion.div
        className="absolute w-40 h-40 rounded-full border-l-2 border-r-2 border-cyan-400 opacity-80"
        animate={{ rotate: -360 }}
        transition={{ repeat: Infinity, duration: 2, ease: "linear" }}
      />

      {/* Brand Image with pulsing effect */}
      <motion.div
        className="relative w-32 h-32 rounded-full overflow-hidden border-2 border-cyan-300 z-10"
        animate={{
          scale: [1, 1.1, 1],
          boxShadow: [
            "0px 0px 15px rgba(34,211,238,0.5)",
            "0px 0px 30px rgba(34,211,238,0.8)",
            "0px 0px 15px rgba(34,211,238,0.5)"
          ]
        }}
        transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
      >
        <img
          src={brandLogo}
          alt="Brand Logo"
          className="w-full h-full object-cover"
        />
      </motion.div>

      {/* Optional Loading text, we can keep it clean or add one */}
      <motion.div 
        className="absolute mt-64 text-cyan-400 font-semibold tracking-widest text-lg"
        animate={{ opacity: [0.3, 1, 0.3] }}
        transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
      >
        LOADING...
      </motion.div>
    </div>
  );
};

export default Loader;
